import {Attribute, Component, forwardRef, Input} from '@angular/core';
import {
    AbstractControl,
    ControlValueAccessor,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR,
    ValidationErrors,
    Validator
} from '@angular/forms';
import {PredefinedColors} from '@ionic/core';

@Component({
    selector: 'checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => CheckboxComponent),
            multi: true
        }
    ]
})
export class CheckboxComponent implements ControlValueAccessor, Validator {

    @Input() required: boolean;
    @Input() color?: PredefinedColors;

    public disabled: boolean;
    public checked: boolean;
    private onNgChange: (value: boolean) => void;
    private onNgTouched: () => void;
    private onValidatorChange: () => void;

    private requiredAttribute: boolean;

    constructor(@Attribute('required') required: any) {
        this.requiredAttribute = required !== null;
    }

    registerOnChange(fn: any): void {
        this.onNgChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onNgTouched = fn;
    }

    registerOnValidatorChange(fn: any): void {
        this.onValidatorChange = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    writeValue(obj: any): void {
        this.checked = obj;
    }

    onCheckedChange(checked: boolean): void {
        this.onNgChange(checked);
        this.checked = checked;
        this.onNgTouched();
        this.onValidatorChange();
    }

    private isRequired(): boolean {
        return this.required || this.requiredAttribute;
    }

    validate(control: AbstractControl): ValidationErrors | null {
        return this.checked || !this.isRequired() ? null : {required: true};
    }
}
